import styled, {keyframes} from 'styled-components'
import * as Define from '../../utils/defines/defines'

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    background: ${Define.BackgroundContainer};
    display: flex;
    padding: 40px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    background-size: cover;
    ${Define.media.mobile`
        background: #17212E;
        padding: 16px;
        flex-direction: column;
        justify-content: space-around;
    `}
`
const CardAnimate = keyframes`
    from{
        right: -40vw;
    }
    to{
        right: 0;
    }
`

export const Card = styled.div`
    height: 100%;
    width: 40vw;
    background: rgba(255,255,255,0.045);
    border: 1px solid rgba(255,255,255,0.09);
    backdrop-filter: blur(20px);
    box-shadow: -8px 0 28px rgba(0,0,0,0.35), inset 1px 0 0 rgba(255,255,255,0.06);
    padding: 60px;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    right: 0;
    animation: .5s ${CardAnimate} ease-in;
    top: 0;
    z-index: 2;
    ${Define.media.mobile`
        width: 100%;
        height: 60vh;
        position: relative;
        right: 0;
        top: 0;
        animation: none;
        padding: 30px 20px;
        border-radius: 10px;
    `}
`

export const Title = styled.p`
    margin: 0;
    font-family: "Montserrat";
    background: -webkit-linear-gradient(45deg, rgb(62, 147, 216), rgb(76, 185, 49));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; 
    font-weight: bold;
    font-size: 48px;
    letter-spacing: 1.5px;
`

export const CardTitle = styled.p`
    margin: 0;
    font-family: "Montserrat";
    color: #fff;
    margin-bottom: 45px; 
    font-weight: bold;
    font-size: 34px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
`
export const Subtitle = styled.p`
    margin: 0;
    font-family: 'Nunito';
    font-size: 20px;
    color: rgba(255,255,255,0.5);
`

export const InputTitle = styled.p`
    margin: 0;
    font-family: "Nunito";
    font-size: 14px;
    font-weight: 400;
    color: #FFF;
    opacity: 0.8;
`

export const ButtonLogin = styled.button`
    width: 100%;
    height: 45px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(90deg, #92B258, #5292D1);
    box-shadow: 0 6px 16px rgba(0,0,0,0.45);

    color: #fff;
    font-family: "Nunito";
    font-weight: 700;
    font-size: 18px;
    cursor: pointer;
    transition: .2s;
    margin-top: 45px;

    :hover{
        filter: brightness(1.08);
        transform: translateY(-1px);
    }
`

export const TextBtn = styled.p`
    margin: 0;
    color: rgba(255,255,255,0.5);
    cursor: pointer;
    text-transform: uppercase;

    font-family: 'Nunito';
    font-size: 12px;
    letter-spacing: 1.5px;
    margin-top: 20px;
    width: 100%;
    text-align: right;
    transition: .3s;
    :hover{
        transition: .3s;
        color: #fff;
    }
`

export const ContactBtn = styled.p`
    margin: 0;
    position: absolute;
    bottom: 20px;
    text-align: center;
    width: 100px;
    right: calc(20vw + 10px);
    color: rgba(255,255,255,0.5);
    cursor: pointer;
    text-transform: uppercase;

    font-family: 'Nunito';
    font-size: 12px;
    letter-spacing: 1.5px;
    ${Define.media.mobile`
        position: static;
        width: 100%;
        margin-top: 12px;
    `}
`

export const Logo = styled.img`
    width: 150px;
    position: absolute;
    
    left: 40px;
    bottom: 40px;
    z-index: 2;
    ${Define.media.mobile`
        position: relative;
        width: 110px;
        left: 16px;
        bottom: 16px;
    `}
`

export const DigitsContent = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`

export const NumberInput = styled.input`
    width: 23%;
    height: 40px;
    border: none;
    border-bottom: solid 2px rgba(255,255,255,0.5);
    background: none;
    outline: none;
    color: white;
    margin-top: 10px;
    padding-left: 9%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    transition: .5s;

    :focus{
        transition: .5s;
        width: 25%;
        border-bottom: solid 2px #FFF;
    }
    ${Define.media.mobile`
        font-size: 16px;
    `}
`

export const CodeInput = styled.input`
    width: 15%;
    height: 40px;
    border: none;
    border-bottom: solid 2px rgba(255,255,255,0.5);
    background: none;
    outline: none;
    color: white;
    margin-top: 10px;
    padding-left: 6%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    transition: .5s;

    :focus{
        transition: .5s;
        width: 16%;
        border-bottom: solid 2px #FFF;
    }
    ${Define.media.mobile`
        font-size: 16px;
    `}
`

const drift = keyframes`
    0%, 100% { transform: translate(0, 0); }
    50% { transform: translate(36px, -26px); }
`

export const Blob1 = styled.div`
    position: absolute;
    width: 24vw;
    height: 24vw;
    min-width: 280px;
    min-height: 280px;
    border-radius: 50%;
    background: #5292D1;
    top: -8vw;
    left: 6%;
    z-index: 1;
    filter: blur(70px);
    opacity: 0.32;
    animation: ${drift} 10s ease-in-out infinite;
    ${Define.media.mobile`
        top: 10vh;
        min-width: 160px;
        min-height: 160px;
    `}
`
export const Blob2 = styled.div`
    position: absolute;
    width: 20vw;
    height: 20vw;
    min-width: 240px;
    min-height: 240px;
    border-radius: 50%;
    background: #92B258;
    bottom: -6vw;
    right: 10%;
    z-index: 1;
    filter: blur(70px);
    opacity: 0.28;
    animation: ${drift} 10s ease-in-out infinite 2s;
    ${Define.media.mobile`
        min-width: 140px;
        min-height: 140px;
    `}
`
export const Blob3 = styled.div`
    position: absolute;
    width: 16vw;
    height: 16vw;
    min-width: 200px;
    min-height: 200px;
    border-radius: 50%;
    background: #E5D34A;
    top: 32%;
    left: 46%;
    z-index: 1;
    filter: blur(70px);
    opacity: 0.18;
    animation: ${drift} 10s ease-in-out infinite 4s;
    ${Define.media.mobile`
        display: none;
    `}
`
export const PasswordContent = styled.div`
    position: relative;
`

export const Icon = styled.div`
    height: 20px;
    width: 20px;
    bottom: 32px;
    right: 18px;
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255,255,255,0.5);
`